import React, {memo} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {filterMessages} from 'components/Filters/filterMessages'
import {FilterUrlParams} from 'modules/search/types'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {
  Checkbox,
  CheckboxBody,
  CheckboxContent
} from '@vio/atlas/src/components/designSystem/Checkbox'
import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import minus from '@vio/atlas/src/utils/minus'
import {cssTheme} from '@vio/atlas-tokens'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const StyledCheckBox = styled(Checkbox)`
  ${CheckboxBody} {
    align-items: flex-start;
  }

  ${CheckboxContent} {
    margin-top: ${minus(cssTheme.layout.spacing.s200)};
  }
`
interface Props {
  filters: FilterUrlParams
  handleSingleFilterChange: (value: FilterUrlParams) => void
}
// Added as a part of c747927f-deal-freeze-srp
const DealFreezeFilterComponent: React.FC<Props> = ({
  filters,
  handleSingleFilterChange
}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  const isDealFreezeFilterActive = filters.dealFreeze === '1'

  return (
    <div>
      <StyledCheckBox
        key="dealFreeze"
        name="dealFreeze"
        value="dealFreeze"
        checked={isDealFreezeFilterActive}
        onChange={() =>
          handleSingleFilterChange({
            dealFreeze: isDealFreezeFilterActive ? undefined : '1'
          })
        }
        label={
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            marginBottom="s200"
          >
            <Text variant="bodyM">
              {formatMessage(filterMessages.freezable)}
            </Text>
            <Text variant="bodyS">
              <FormattedMessageWrapper
                id="dealFreeze.allFiltersSectionDescription"
                defaultMessage="Guarantee the room and price while you decide"
              />
            </Text>
          </Box>
        }
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
    </div>
  )
}

export const DealFreezeFilter = memo(DealFreezeFilterComponent)
